import Head from 'next/head'
import styles from '@/styles/About.module.css'
import dynamic from 'next/dynamic'

const Burgare = dynamic(() => import('@/components/Burgare'))

const burgare = () => {
  // const generateMissingImage = (width = 200, height = 100, alt) => {
  //   if (typeof width !== 'number' || typeof height !== 'number') {
  //     return (
  //       <Image
  //         src={HomeImage}
  //         className={styles.imageUrl}
  //         width={width}
  //         height={height}
  //         alt={alt || 'Image Not Available'}
  //         loading='lazy'
  //       />
  //     ) // or some default image URL
  //   }
  //   return `https://via.placeholder.com/${width}x${height}`
  // }
  const itemList = [
    {
      '@type': 'ListItem',
      position: 1,
      url: 'https://labambi.se/burgare',
      name: 'Burgare',
      description: 'Explore our delicious burger menu',
    },
    {
      '@type': 'ListItem',
      position: 2,
      item: {
        '@type': 'MenuItem',
        name: 'Hamburgare',
        description: 'Classic hamburgers made with the finest ingredients',
        url: 'https://labambi.se/burgare/hamburgare',
      },
    },
    {
      '@type': 'ListItem',
      position: 3,
      item: {
        '@type': 'MenuItem',
        name: 'Smashburgare',
        description: 'Juicy smashburgers cooked to perfection',
        url: 'https://labambi.se/burgare/smashburgare',
      },
    },
  ]

  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Hela Burgare Meny</title>
        <meta
          name='description'
          content='Välkommen till La Bambi, där du hittar de mest utsökta burgarna tillverkade med färska och högkvalitativa ingredienser. Utforska vår breda meny med klassiska hamburgare och saftiga smashburgare, tillagade med kärlek och serverade med en leende personal.'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              itemListElement: itemList,
            }),
          }}
        ></script>
      </Head>
      <Burgare />
    </main>
  )
}

export default burgare
